import styled from 'styled-components';

// Shared by the in-table marker and anything else that needs a status dot, so a dot can't drift into
// meaning two different things on one screen.
export const MarkerDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ theme, $token }) => theme.themeColors[$token] || theme.themeColors.secondaryText};
`;
